import Leaflet from 'leaflet';
import icon from 'leaflet/dist/images/marker-icon.png';
import iconShadow from 'leaflet/dist/images/marker-shadow.png';


// marker setting
const DefaultIcon = Leaflet.icon({
    // iconUrl: icon,
    iconUrl: "./icons/marker-location.svg",
    shadowUrl: iconShadow,
    iconAnchor: [12, 41], // アイコンのとがった位置をクリックした場所に合わせるためのオフセット
    popupAnchor: [0, -32], // ポップアップの位置も合わせて調整
});
Leaflet.Marker.prototype.options.icon = DefaultIcon;

export const gpsIcon = Leaflet.icon({
    iconUrl: "./icons/marker-location.svg",
    shadowUrl: iconShadow,
    iconAnchor: [12, 41], // アイコンのとがった位置をクリックした場所に合わせるためのオフセット
    popupAnchor: [0, -32], // ポップアップの位置も合わせて調整
});

export const sightseeingIcon = Leaflet.icon({
    iconUrl: "./icons/marker-sightseeing.svg",
    shadowUrl: iconShadow,
    iconAnchor: [12, 41], // アイコンのとがった位置をクリックした場所に合わせるためのオフセット
    popupAnchor: [0, -32], // ポップアップの位置も合わせて調整
});